/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ReviewNestedService
 */
export interface ReviewNestedService {
  /**
   *
   * @type {number}
   * @memberof ReviewNestedService
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof ReviewNestedService
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof ReviewNestedService
   */
  slug?: string | null
}

/**
 * Check if a given object implements the ReviewNestedService interface.
 */
export function instanceOfReviewNestedService(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function ReviewNestedServiceFromJSON(json: any): ReviewNestedService {
  return ReviewNestedServiceFromJSONTyped(json, false)
}

export function ReviewNestedServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReviewNestedService {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function ReviewNestedServiceToJSON(value?: ReviewNestedService | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    slug: value.slug,
  }
}
